import { render, staticRenderFns } from "./upgrade.vue?vue&type=template&id=f1e188cc&scoped=true&"
import script from "./upgrade.vue?vue&type=script&lang=js&"
export * from "./upgrade.vue?vue&type=script&lang=js&"
import style0 from "./upgrade.vue?vue&type=style&index=0&id=f1e188cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e188cc",
  null
  
)

export default component.exports